// eslint-disable-next-line import/no-extraneous-dependencies
const d3 = require('d3')

const d3schemeCategory20 = [
    '#1f77b4',
    '#aec7e8',
    '#ff7f0e',
    '#ffbb78',
    '#2ca02c',
    '#98df8a',
    '#d62728',
    '#ff9896',
    '#9467bd',
    '#c5b0d5',
    '#8c564b',
    '#c49c94',
    '#e377c2',
    '#f7b6d2',
    '#7f7f7f',
    '#c7c7c7',
    '#bcbd22',
    '#dbdb8d',
    '#17becf',
    '#9edae5',
]

const outfield = ['lf', 'cf', 'rf']
const infield = ['2b', '3b', 'ss']
const positions = ['1b', ...infield, ...outfield, 'p', 'c']

const positionMap = {
    1: 'p',
    2: 'c',
    3: '1b',
    4: '2b',
    5: '3b',
    6: 'ss',
    7: 'lf',
    8: 'cf',
    9: 'rf',
    10: 'dh',
    11: 'ph',
}
const colorScale = d3.scaleOrdinal().domain(positions).range(d3schemeCategory20)

function colorScaleNumbers(val) {
    const pos = positionMap[val]
    return colorScale(pos)
}
module.exports = {
    colorScale,
    colorScaleNumbers,
    positions,
    positionMap,
}
